/**
 * queryKeys — Centralized query key factory
 *
 * Why use a factory?
 *  - No hardcoded strings scattered across files
 *  - Invalidation is precise: invalidate 'customers.list' without touching 'customers.detail'
 *  - Easy to read what each query does
 *
 * Usage examples:
 *  queryKeys.customers.all            → ['customers']
 *  queryKeys.customers.list()         → ['customers', 'list']
 *  queryKeys.customers.detail(42)     → ['customers', 'detail', 42]
 */
export const queryKeys = {
  // ── Customers ────────────────────────────────────────────────────────────────
  customers: {
    all: ['customers'],
    list: (page = 1, search = '', customerId = '', salesMode = '', reminderMonth = '') => [
      'customers', 'list', { page, search, customerId, salesMode, reminderMonth }
    ],
    detail: (id) => ['customers', 'detail', id],
  },

  // ── Suppliers ────────────────────────────────────────────────────────────────
  suppliers: {
    all: ['suppliers'],
    list: (page = 1, search = '') => ['suppliers', 'list', { page, search }],
    detail: (id) => ['suppliers', 'detail', id],
  },

  // ── Users ─────────────────────────────────────────────────────────────────
  users: {
    all: ['users'],
    list: (page = 1, search = '') => ['users', 'list', { page, search }],
    detail: (id) => ['users', 'detail', id],
  },

  // ── Auth ──────────────────────────────────────────────────────────────────
  auth: {
    profile: () => ['auth', 'profile'],
  },

  // ── Packing List ──────────────────────────────────────────────────────────
  packingList: {
    all: ['packingList'],
    list: (page = 1, search = '', agent = '', status = '') => [
      'packingList', 'list', { page, search, agent, status }
    ],
    detail: (id) => ['packingList', 'detail', id],
  },
  // ── Port Loading (Origins) ────────────────────────────────────────────────
  portLoading: {
    all: ['portLoading'],
  },

  // ── Data Entry ────────────────────────────────────────────────────────────
  dataEntry: {
    all: ['dataEntry'],
    list: (page = 1, search = '') => ['dataEntry', 'list', { page, search }],
    detail: (id) => ['dataEntry', 'detail', id],
    // Document sub-keys
    quoteDoc: (id) => ['dataEntry', id, 'quoteDoc'],
    draftBlDoc: (id) => ['dataEntry', id, 'draftBlDoc'],
    rolloverDoc: (id) => ['dataEntry', id, 'rolloverDoc'],
    copyDocs: (id) => ['dataEntry', id, 'copyDocs'],
    containerImage: (id, containerNo) => ['dataEntry', id, 'containerImage', containerNo],
  },
};



